import { render, staticRenderFns } from "./TripleOriginPopView.vue?vue&type=template&id=77f84bd4"
import script from "./TripleOriginPopView.vue?vue&type=script&lang=js"
export * from "./TripleOriginPopView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports